import React, { useContext, useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import {
    Card,
    CardBody,
    Col,
    Container,
    Form,
    FormFeedback,
    Input,
    Label,
    Row,
} from "reactstrap";

import Select from "react-select";
import Breadcrumbs from "components/Common/Breadcrumb";

import { useFormik } from "formik";
import * as Yup from "yup";

import CommonDialog from "components/Common/CommonDialog";
import ToastDialog from "components/Common/ToastDialog";

import { AddSapUser, editSapUser, getSapUser, getSapUserOptions } from "helpers/UAM/user.helper";
import {  isEmpty } from "lodash";
import ReactInputMask from "react-input-mask";
import { getDataAccessForRole } from "helpers/UAM/roleDataAccess.helper";
import { getReportToListForSelect, getSalesOfficeListForSelect } from "helpers/UAM/salesoffice.helper";
import { SystemConfigurationContext } from "context/systemConfigContext";
import { getRegionList } from "http/Region";
import _debounce from "lodash/debounce";
const AddUser = () => {

    // Routes vars
    const { id } = useParams();

    const userId = !isEmpty(id) ? atob(id) : null;

    const [toastInfo, setToastInfo] = useState({ showToast: false });
    const [salesOfficeOptions, setSalesOfficeOptions] = useState([]);
    const [regionOptions, setRegionOptions] = useState([]);
    const [roleOptions, setRoleOptions] = useState([]);
    const [reportsToOptions, setReportsToOptions] = useState([]);

    const [showRegion, setShowRegion] = useState(false);
    const [showSalesOffice, setShowSalesOffice] = useState(false);

    const [showCommonDialog, setShowCommonDialog] = useState({ isShow: false });
    const navigate = useNavigate();
    const {inputMax} = useContext(SystemConfigurationContext)

    const urlParams = new URLSearchParams(window.location.search)
    const encodedId = urlParams.get("id")
    document.title = userId ? "Edit User | DMS" : "Add User | DMS"

    const {roleName}= JSON.parse(localStorage.getItem("user"))

    const getOptionsForUser = async () => {
        const response = await getSapUserOptions();
        if (response.status) {
            setOptions(response.data)
        }
        else {
            setToastInfo({ message: response.message, showToast: true, role: "error" });
        }
    };


    const setOptions = (data) => {
        const { roles, reportingTo } = data;

        if (!isEmpty(roles)) {
            setRoleOptions(roles.map(item => {
                return { label: item['displayName'], value: item['id'] }
            }))
        }
    }

    const setDataInFormik = (data) => {

        validation.setFieldValue("firstName", data.firstName ? data.firstName : "");
        validation.setFieldValue("lastName", data.lastName ? data.lastName : "");
        validation.setFieldValue("email", data.email ? data.email : "");
        validation.setFieldValue("region", data.region ? data.region : []);
        validation.setFieldValue("phone", data.mobileNo ? data.mobileNo : "");
        validation.setFieldValue("roleId", data.roleId ? data.roleId : "");
        validation.setFieldValue("salesOffice", data.salesOffice ? data.salesOffice : []);
        validation.setFieldValue("reportsTo", data.reportsTo ? data.reportsTo : "");
        validation.setFieldValue("userId", data.userId ? data.userId : "");
    }


    async function getUserInfo(userId) {
        const response = await getSapUser({ id: userId });
        if (response.status) {
            setDataInFormik(response.data);
        }
        else {
            setToastInfo({ message: response.message, showToast: true, role: "error" });
        }
    }

    useEffect(() => {
        getOptionsForUser();
        if (!isEmpty(userId)) {
            getUserInfo(userId);
        }
    }, [userId]);





    const validation = useFormik({
        enableReinitialize: true,

        initialValues: {
            firstName: "",
            lastName: "",
            email: "",
            phone: "",
            roleId: "",
            salesOffice: [],
            region: [],
            reportsTo: "",
            userId: "",
        },

        validationSchema: Yup.object({
            firstName: Yup.string().required("Please Enter First Name"),
            lastName: Yup.string().required("Please Enter Last Name"),
            email: Yup.string().email('Invalid email').required("Please Enter Email"),
            phone: Yup.string()
            .typeError("Mobile No must be a number")
            .required("Please Enter Mobile No")
            .matches(/^\d{10}$/, "Mobile Number must be exactly 10 digits"),
            salesOffice: showSalesOffice ? Yup.array().min(1, "Please Select at least one Sales office").required("Please Select Sales Office") : Yup.array(),
            roleId: Yup.number().required("please Select Role"),
            region: showRegion ? Yup.array().min(1, "Please Select at least one Region").required("Please Select Region") : Yup.array(),
            reportsTo: Yup.number(),
            userId: Yup.string().required("Please Enter Employee Id"),
        }),

        onSubmit: (values) => {
            const message = userId ?  'Do you want to update user?':'Do you want to save entry?'
            setShowCommonDialog({ isShow: true, message })
        }
    });

    


    const handleCancel = () => {
        navigate(-1)
    }

    const submitUser = async () => {
        const { values } = validation
        const userData = {
            firstName: values.firstName,
            lastName: values.lastName,
            email: values.email,
            phone: (values.phone),
            roleId: values.roleId,
            region: values.region,
            salesOffice: values.salesOffice,
            reportsTo: values.reportsTo,
            userId: values.userId,
        };

        if (userId) {
            userData.id = userId
        }

        const apiRes = userId ? await editSapUser(userData) : await AddSapUser(userData);

        if (apiRes.status) {
            setToastInfo({ message: apiRes.message, showToast: true, role: "success" });
            navigate(`/${roleName}/users`)
        } else {
            setToastInfo({ message: apiRes.message, showToast: true, role: "error" });
        }

    }

    const dialogAction = (action, data) => {
        if (action == 1) {
            setShowCommonDialog({ isShow: false })
            submitUser()
        } else {
            setShowCommonDialog({ isShow: false })
        }
    }

    const getRegionLists = async () => {
        const apiRes = await getRegionList();
        if (apiRes.status) {
            const  regions  = apiRes?.data?.data
            setRegionOptions(regions.map(item => {
                return { label: item['regionName'], value: item['regionName'] }
            }));
        } else {
            setToastInfo({ message: apiRes.message, showToast: true, role: "error" });
        }
    }

    const getSalesOfficeData = async (region) => {
        const response = await getSalesOfficeListForSelect({ region });
        if (response.status) {
            const { salesOfficeData } = response.data;
            setSalesOfficeOptions(salesOfficeData.map(item => {
                return { label: item['salesOfficeCode'], value: item['id'] }
            }));
        }
        else {
            if (showSalesOffice) setToastInfo({ message: response.message, showToast: true, role: "error" });
        }

    }

    const getDataAccessInfo = async (roleId) => {
        const apiRes = await getDataAccessForRole({ roleId });
        if (apiRes.status) {
            const { access } = apiRes.data
            if (access == 'All') {
                setShowRegion(false)
                setShowSalesOffice(false)
            } else if (access == 'Region') {
                setShowRegion(true)
                getRegionLists()
                setShowSalesOffice(false)
            } else if (access == 'Store') {
                setShowRegion(true)
                getRegionLists()
                setShowSalesOffice(true)
            }
        } else {
            setToastInfo({ message: apiRes.message, showToast: true, role: "error" });
            setShowRegion(false)
            setShowSalesOffice(false)
        }
    }

    const getReportsToList = async (salesOffice, searchKey='') => {
        const bodyData = {
            salesOffice: salesOffice,
            roleId: validation.values.roleId,
            userId: userId,
            limit:10,
            searchKey
        }

        const apiRes = await getReportToListForSelect(bodyData);
        if (apiRes.status) {
            const { users } = apiRes.data
            setReportsToOptions(users.map(item => {
                return { label: item['firstName'], value: item['id'] }
            }));
        } else {
            setToastInfo({ message: apiRes.message, showToast: true, role: "error" });
        }
    }

    useEffect(() => {
        if (!validation.values.roleId) return
        setRegionOptions([])
        setSalesOfficeOptions([])
        getDataAccessInfo(validation.values.roleId)
        getReportsToList([])
    }, [validation.values.roleId]);

    useEffect(() => {
        if (!validation.values.region) return
        setSalesOfficeOptions([])
        getSalesOfficeData(validation.values.region)
    }, [validation.values.region]);

    useEffect(() => {
        if (isEmpty(validation.values.salesOffice)) return
        setReportsToOptions([])
    }, [validation.values.salesOffice]);

    
    const debouncedGetReportsToList = _debounce(getReportsToList, 300);
    return (
        <React.Fragment>
            <div className="page-content pb-5">
                <div className="ms-2">
                <Breadcrumbs title="User" breadcrumbItem={userId ? "Edit User" : "Add User"} />
                </div>
                <Container fluid style={{marginBottom:'160px'}}>
                    <Card>
                        <CardBody>
                            <Form
                                onSubmit={(e) => {
                                    e.preventDefault();
                                    validation.handleSubmit();
                                    return false;
                                }}
                            >
                                <h5 className="mt-2" style={{ color: "#7B8788" }}>{isEmpty(userId) && 'New'} User</h5>
                                <Row>


                                    <Col sm="12" md="6">
                                        <Label className="form-label mt-3 required">First Name
                                            
                                        </Label>
                                        <Input
                                            name="firstName"
                                            maxLength={inputMax}
                                            placeholder="Enter First Name"
                                            type="text"
                                            className={`form-control ${validation.touched.firstName && validation.errors.firstName ? "is-invalid" : ""}`}
                                            id="firstname"
                                            onChange={validation.handleChange}
                                            onBlur={validation.handleBlur}
                                            value={validation.values.firstName || ""}
                                            invalid={(validation.touched.firstName && validation.errors.firstName)}
                                        />
                                        {validation.touched.firstName && validation.errors.firstName ? (
                                            <FormFeedback type="invalid">{validation.errors.firstName}</FormFeedback>
                                        ) : null}
                                    </Col>

                                    <Col sm="12" md="6">
                                        <Label className="form-label mt-3 required">Last Name
                                           
                                        </Label>
                                        <Input
                                            name="lastName"
                                            maxLength={inputMax}
                                            placeholder="Enter Last Name"
                                            type="text"
                                            className={`form-control ${validation.touched.lastName && validation.errors.lastName ? "is-invalid" : ""}`}
                                            id="lastname"
                                            onChange={validation.handleChange}
                                            onBlur={validation.handleBlur}
                                            value={validation.values.lastName || ""}
                                            invalid={(validation.touched.lastName && validation.errors.lastName)}
                                        />
                                        {validation.touched.lastName && validation.errors.lastName ? (
                                            <FormFeedback type="invalid">{validation.errors.lastName}</FormFeedback>
                                        ) : null}
                                    </Col>

                                    <Col sm="12" md="6">
                                        <Label className="form-label mt-3 required">Email
                                            
                                        </Label>
                                        <Input
                                            name="email"
                                            maxLength={inputMax}
                                            placeholder="Enter Email"
                                            type="email"
                                            className={`form-control ${validation.touched.email && validation.errors.email ? "is-invalid" : ""}`}
                                            id="validationEmail"
                                            onChange={validation.handleChange}
                                            onBlur={validation.handleBlur}
                                            value={validation.values.email || ""}
                                            invalid={(validation.touched.email && validation.errors.email)}
                                        />
                                        {validation.touched.email && validation.errors.email ? (
                                            <FormFeedback type="invalid">{validation.errors.email}</FormFeedback>
                                        ) : null}
                                    </Col>
                                    <Col sm="12" md="6">
                                        <Label className="form-label mt-3 required">Mobile
                                            
                                        </Label>
                                        <ReactInputMask
                                            mask={"9999999999"}
                                            maskChar={null}
                                            name="phone"
                                            placeholder="Enter Mobile Number"
                                            className={`form-control ${validation.touched.phone && validation.errors.phone ? "is-invalid" : ""}`}
                                            id="validationphone"
                                            onChange={validation.handleChange}
                                            onBlur={validation.handleBlur}
                                            value={validation.values.phone || ""}
                                            invalid={(validation.touched.phone && validation.errors.phone)}

                                        />
                                        {validation.touched.phone && validation.errors.phone ? (
                                            <FormFeedback type="invalid">
                                                {validation.errors.phone}
                                            </FormFeedback>
                                        ) : null}
                                    </Col>

                                    <Col sm="12" md="6">
                                        <Label className="form-label mt-3 required">Role
                                            
                                        </Label>
                                        <Select
                                            options={roleOptions}
                                            className={`select-dropdown ${validation.touched.roleId && validation.errors.roleId ? "is-invalid" : ""}`}
                                            name="roleId"
                                            id="roleId"
                                            onChange={(selectedOption) => {
                                                validation.setFieldValue("salesOffice", [])
                                                validation.setFieldValue("region", "")
                                                validation.setFieldValue("roleId", selectedOption.value);
                                            }}
                                            value={roleOptions.find((option) => option.value == validation.values.roleId)}

                                        />
                                        {validation.touched.roleId && validation.errors.roleId ? (
                                            <FormFeedback type="invalid">{validation.errors.roleId}</FormFeedback>
                                        ) : null}
                                    </Col>

                                    <Col sm="12" md="6">
                                        <Label className="form-label mt-3 required">Employee Id
                                            
                                        </Label>
                                        <ReactInputMask
                                            name="userId"
                                            placeholder="Enter Employee Id"
                                            className={`form-control ${validation.touched.userId && validation.errors.userId ? "is-invalid" : ""}`}
                                            id="validationphone"
                                            onChange={validation.handleChange}
                                            onBlur={validation.handleBlur}
                                            value={validation.values.userId || ""}
                                            invalid={(validation.touched.userId && validation.errors.userId)}

                                        />
                                        {validation.touched.userId && validation.errors.userId ? (
                                            <FormFeedback type="invalid">
                                                {validation.errors.userId}
                                            </FormFeedback>
                                        ) : null}
                                    </Col>


                                    {showRegion && <Col sm="12" md="6">
                                        <Label className="form-label mt-3 required">Region
                                            
                                        </Label>
                                        <Select
                                            isMulti
                                            options={regionOptions}
                                            className={`select-dropdown ${validation.touched.region && validation.errors.region ? "is-invalid" : ""}`}
                                            name="region"
                                            id="region"
                                            onChange={(selectedOption) => {
                                                validation.setFieldValue("salesOffice", [])
                                                validation.setFieldValue("region", selectedOption.map(item => item.value));
                                            }}
                                            
                                            value={
                                                regionOptions.filter((option) => {
                                                return validation.values.region.includes(option.value)
                                               })
                                            }
                                        />

                                        {validation.touched.region && validation.errors.region ? (
                                            <FormFeedback type="invalid">{validation.errors.region}</FormFeedback>
                                        ) : null}
                                    </Col>}

                                    {showSalesOffice && <Col sm="12" md="6">
                                        <Label className="form-label mt-3 required">Sales Office
                                            
                                        </Label>
                                        <Select
                                            options={salesOfficeOptions}
                                            isMulti
                                            className={`select-dropdown ${validation.touched.salesOffice && validation.errors.salesOffice ? "is-invalid" : ""}`}
                                            name="salesOffice"
                                            id="salesOffice"
                                            onChange={(selectedOption) => {
                                                validation.setFieldValue("reportsTo", "")
                                                validation.setFieldValue("salesOffice", selectedOption.map(item => item.value));
                                            }}
                                            value={
                                                salesOfficeOptions.filter((option) => {
                                                    return validation.values.salesOffice.includes(option.value)
                                                })
                                            }
                                        />
                                        {validation.touched.salesOffice && validation.errors.salesOffice ? (
                                            <FormFeedback type="invalid">{validation.errors.salesOffice}</FormFeedback>
                                        ) : null}
                                    </Col>}

                                    <Col sm="12" md="6">
                                        <Label className="form-label mt-3">Reports To
                                        </Label>
                                        <Select
                                            options={reportsToOptions}
                                            className={`select-dropdown ${validation.touched.salesOffice && validation.errors.salesOffice ? "is-invalid" : ""}`}
                                            name="reportsTo"
                                            id="reportsTo"
                                            onChange={(selectedOption) => {
                                                validation.setFieldValue("reportsTo", selectedOption.value);
                                            }}
                                            onInputChange={e => {
                                                debouncedGetReportsToList([], e)
                                              }}
                                            value={
                                                reportsToOptions.filter((option) => {
                                                    return validation.values.reportsTo == option.value
                                                })
                                            }
                                        />
                                        {validation.touched.reportsTo && validation.errors.reportsTo ? (
                                            <FormFeedback type="invalid">{validation.errors.reportsTo}</FormFeedback>
                                        ) : null}
                                    </Col>

                                </Row>

                                <Row>
                                    <Col className="mt-4">
                                        <div className="d-flex gap-3 justify-content-end">
                                            <button
                                                className="btn btn-outline-secondary"
                                                type="button"
                                                onClick={handleCancel}
                                            >
                                                Cancel
                                            </button>
                                            <button
                                                type="submit"
                                                className="btn btn-success save-customer"
                                            >
                                                Save
                                            </button>
                                        </div>
                                    </Col>
                                </Row>


                            </Form>
                        </CardBody>
                    </Card>
                </Container>
            </div>
            {
                showCommonDialog &&
                <CommonDialog
                    isShow={showCommonDialog.isShow}
                    message={showCommonDialog.message} data={showCommonDialog.data}
                    postitiveBtn={'Submit'} negativeBtn={'Close'} onCloseFn={dialogAction}
                />
            }
            <ToastDialog
                message={toastInfo.message}
                showToast={toastInfo.showToast}
                role={toastInfo.role}
                onCloseFn={() => setToastInfo({ showToast: false })}
            />
        </React.Fragment>

    )
}

export default AddUser